//main
import ContentFormatXX from '../content/webc/content-format-xx';

import WebbDividerSmall from "../content/webb/webb-divider-sm";
import HeaderSectionDark from "../content/webb/head-section-dark";

import TransferDebitModule from '../content/transfers/transfer-debit';

import { UserForm } from "../services/srvc-utilities";

export default function TransfersDebit() {

  return (
  <>
    <ContentFormatXX 
      head='Transfer Funds'
      link={`/${UserForm()}/home`}
      form= 'mini'
      data= {
        <>
          <WebbDividerSmall />
          <TransferDebitModule />


        </>
      } 
    />
  </>
  )
}